export type CookiebotConsent = {
  necessary?: boolean;
  preferences?: boolean;
  statistics?: boolean;
  marketing?: boolean;
};

export type CookiebotApi = {
  consent?: CookiebotConsent;
  renew?: () => void;
  show?: () => void;
};

declare global {
  interface Window {
    Cookiebot?: CookiebotApi;
  }
}

export const COOKIEBOT_ENABLED = Boolean(
  process.env.NEXT_PUBLIC_COOKIEBOT_CBID
);
